import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import btnArrow from "./../../images/ArrowRightWhite.svg";
import { Link } from "react-router-dom";
import { UserContext } from "../../lib/context";
import LoadingSpinner from "../LoadingSpinner";

class TabMonoMorphCard extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
    this.items = [];
    for (var i = 0; i < this.props.tabData.tabs.length; i++) {
      if (i !== this.props.tabData.tabs.length - 1) {
        this.items.push(
          <Nav.Link
            key={i}
            href={this.props.tabData.tabs[i].link}
            className={`tabTxtMono ${
              this.props.currentSection === i ? "color" : ""
            } `}
          >
            {this.props.tabData.tabs[i].name}
          </Nav.Link>
        );
      } else {
        this.items.push(
          <Link
            key={i}
            className={`tabTxtMono ${
              this.props.currentSection === i ? "color" : ""
            } `}
            to={`manual`}
          >
            {this.props.tabData.tabs[i].name}
          </Link>
        );
      }
    }
  }

  orderNow = async event => {
    event.preventDefault();
    this.setState({ loading: true });
    console.log(this.country);
    this.redirectToCheckout = true;

    try {
      // Use the new Cart API with GraphQL mutation instead of deprecated checkout API
      const query = `
        mutation cartCreate($input: CartInput!) {
          cartCreate(input: $input) {
            cart {
              id
              checkoutUrl
            }
            userErrors {
              field
              message
            }
          }
        }
      `;

      const variables = {
        input: {
          lines: [
            {
              quantity: 1,
              merchandiseId: this.props.shopifyLink
            }
          ]
        }
      };

      const response = await fetch(`https://norandstore.myshopify.com/api/2024-04/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '4afd7898ce2dc3f58b7ff3407f8d1b7b'
        },
        body: JSON.stringify({ query, variables })
      });

      const data = await response.json();
      
      if (data.data && data.data.cartCreate && data.data.cartCreate.cart) {
        const checkoutUrl = data.data.cartCreate.cart.checkoutUrl;
        if (checkoutUrl) {
          window.location.href = checkoutUrl;
        } else {
          console.error('No checkout URL returned');
          this.setState({ loading: false });
        }
      } else {
        console.error('Cart creation failed:', (data.data && data.data.cartCreate && data.data.cartCreate.userErrors) || data.errors);
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error('Error creating cart:', error);
      this.setState({ loading: false });
    }
  };

  render() {
    return (
      <>
        {this.state.loading && <LoadingSpinner />}
        <Navbar
          collapseOnSelect
          expand="lg"
          variant="dark"
          bg="none"
          className={`tabMonoContainer ${
            this.props.fixed ? "tabMonoFixed" : ""
          }`}
          hidden={!this.props.fixed}
        >
          <Navbar.Toggle hidden aria-controls="responsivemono-nav" />
          <Navbar.Collapse id="responsivemono-nav">
            <Nav className="me-auto">{this.items}</Nav>
          </Navbar.Collapse>
          <Link to={"/join-waitlist"}>
            <Nav className="rightIconPartMono">
              {/* <button onClick={this.orderNow} className="btnOrderNowTab"> */}
              <button onClick={this.orderNow} className="btnOrderNowTab">
                Out of stock. Join waitlist
                {/* <UserContext.Consumer>
                  {priceInEur => (priceInEur ? "€" : "$")}
                </UserContext.Consumer> */}
                <img src={btnArrow} alt="" className="arrowButtonMonoProduct" />
              </button>
            </Nav>
          </Link>
        </Navbar>
      </>
    );
  }
}

export default TabMonoMorphCard;
